import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, Icon, Table, Button, message } from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import { Translate } from "react-translated";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import CustomHeader from '../../CommonHeader/CustomHeader';

class OrderHistory extends Component {
  state = {
    loading: true,
    order_history: [],
    page: 1,
    total_pages: 0,
  };
  componentDidMount = () => {
    this.loadOrderHistory(1);
  };
  loadOrderHistory = (page) => {
    const api = "/api/tango/order_history?page=" + page;
    this.setState({ loading: true });
    axios.get(api).then((res) => {
      const order_history = res.data.orders;
      this.setState({
        loading: false,
        page: page,
        total_pages: res.data.page && res.data.page.totalCount ? res.data.page.totalCount : 0,
        order_history,
      });
    });
  };
  resend = (order_id) => {
    this.setState({ loading: true });
    axios
      .post("/api/tango/resend_reward_email", { order_id })
      .then((res) => {
        if (
          typeof res.data.errors !== "undefined" &&
          res.data.errors.length > 0
        ) {
          this.setState({ loading: false });
          for (let i = 0; i < res.data.errors.length; i++) {
            message.error(res.data.errors[i].message);
          }
        } else {
          this.setState({ loading: false });
          message.success(F.translate(`Email has been successfully sent.`));
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error(F.translate(`Please try again later.`));
      });
  };
  render() {
    const { loading, order_history, page, total_pages } = this.state;

    // Define AgGrid column definitions
    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Delivered at"} />,
        field: 'date',
        minWidth: 180,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Delivered at'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'date',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.date}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Recipient"} />,
        field: 'recipient',
        minWidth: 250,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Recipient'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'recipient',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.recipient}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Amount"} />,
        field: 'amount',
        minWidth: 120,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Amount'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'amount',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.amount}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: <Translate text={"Actions"} />,
        field: 'action',
        minWidth: 180,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Actions'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'action',
        }),
        cellRendererFramework: (params) => (
          <div className="right-align">
            <Button
              style={{ marginLeft: 10 }}
              type="primary"
              ghost
              onClick={() => this.resend(params.data.order_id)}
            >
              <Translate text={`Resend Email`} />
            </Button>
          </div>
        ),
      },
    ];

    // Prepare row data for AgGrid
    const rowDatas = order_history.map((item, i) => ({
      key: i,
      order_id: item.order_id,
      date: moment(item.createdAt).format("MM/DD/YYYY hh:mmA"),
      recipient:
        item.recipient.firstName +
        " " +
        item.recipient.lastName +
        " (" +
        item.recipient.email +
        ")",
      amount: F.dollar_format(item.amount_charged.value),
      action: '', // Action handled by cellRendererFramework
    }));

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              <Translate text={`Order History`} />
            </div>
          }
          className="tableCard"
          loading={loading}
        >
          <CustomAgGridTable
            rowDatas={rowDatas}
            columnDefss={columnDefs}
          />
          <Pagination
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadOrderHistory(page);
            }}
          />
        </Card>
      </div>
    );
  }
}

export default OrderHistory;



// WEBPACK FOOTER //
// ./src/scenes/RewardProgram/order-history.js